import { Dayjs } from 'dayjs';
import React from 'react';
import { FormattedDate } from 'react-intl';
import { Props } from 'react-intl/dist/components/relative';
import { Time } from './Time';

interface DataProps {
  data: Dayjs
}

export const Data: React.FC<DataProps & Props> = ({data}) => {
  return <Time data={data}>
    <FormattedDate
      value={data.toDate()} />
  </Time>;
}
